module.exports = __webpack_public_path__ + "static/img/company3.3c6d723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company3.png
// module id = zCwK
// module chunks = 8